export const ENVIRONMENTS = {
    DEVELOPMENT: 'development',
    BETA: 'beta',
    STAGING: 'staging',
    PRODUCTION: 'production',
};
//# sourceMappingURL=environment.constants.js.map